<div class="specialties-admin">

  <!-- =====================================================
       TOOLBAR
  ====================================================== -->

  <div class="specialties-toolbar">
    <div class="specialties-toolbar-left">

      <div class="specialties-search">
        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Buscar especialidad por nombre...">

        <i class="fi fi-rr-search"></i>
      </div>

      <button
        type="button"
        class="specialty-filter-btn"
        [class.active]="activeFilter === 'all'"
        (click)="setFilter('all')">
        Todas
      </button>

      <button
        type="button"
        class="specialty-filter-btn"
        [class.active]="activeFilter === 'active'"
        (click)="setFilter('active')">
        Activas
      </button>

      <button
        type="button"
        class="specialty-filter-btn"
        [class.active]="activeFilter === 'inactive'"
        (click)="setFilter('inactive')">
        Inactivas
      </button>
    </div>

    <button
      type="button"
      class="new-specialty-btn"
      (click)="openCreateModal()">

      <i class="fi fi-rr-plus"></i>
      Nueva especialidad
    </button>
  </div>

  <!-- =====================================================
       LOADING
  ====================================================== -->

  <div class="specialties-loading" *ngIf="loading">
    Cargando especialidades...
  </div>

  <!-- =====================================================
       TABLA
  ====================================================== -->

  <div class="specialties-table-card" *ngIf="!loading">
    <table class="specialties-table">

      <thead>
        <tr>
          <th>ESPECIALIDAD</th>
          <th>DURACIÓN CONSULTA</th>
          <th>TARIFA GENERAL</th>
          <th>PROFESIONALES</th>
          <th>ESTADO</th>
          <th class="color-header">COLOR</th>
          <th class="actions-header"></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let especialidad of filteredSpecialties">

          <td data-label="Especialidad">
            <strong class="specialty-name">
              {{ especialidad.spe_name }}
            </strong>
          </td>

          <td data-label="Duración consulta">
            {{ getSpecialtyDuration(especialidad) }} minutos
          </td>

          <td data-label="Tarifa general">
            {{ formatPrice(getSpecialtyPrice(especialidad)) }}
          </td>

          <td data-label="Profesionales">
            <span class="professionals-text">
              {{ getProfessionalsLabel(especialidad) }}
            </span>
          </td>

          <td data-label="Estado">
            <span
              class="specialty-status"
              [ngClass]="getStatusClass(especialidad)">

              <span class="specialty-status-dot"></span>
              {{ getStatusLabel(especialidad) }}
            </span>
          </td>

          <td
            data-label="Color"
            class="specialty-table-color-cell">

            <span
              class="specialty-table-color"
              [class.without-color]="getSpecialtyColorId(especialidad) === null"
              [style.backgroundColor]="getSpecialtyColorHex(especialidad)"
              [title]="getSpecialtyColorTooltip(especialidad)">
            </span>
          </td>

          <td
            data-label="Acciones"
            class="specialty-actions">

            <button
              type="button"
              class="specialty-action-btn"
              (click)="openEditModal(especialidad)">
              Editar
            </button>

            <button
              type="button"
              class="specialty-action-btn"
              (click)="toggleSpecialtyStatus(especialidad)">

              {{
                isSpecialtyActive(especialidad)
                  ? 'Desactivar'
                  : 'Activar'
              }}
            </button>
          </td>
        </tr>

        <tr *ngIf="filteredSpecialties.length === 0">
          <td colspan="7" class="empty-specialties">
            No se encontraron especialidades.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- =====================================================
       MODAL CREAR
  ====================================================== -->

  <div
    class="specialty-modal-backdrop"
    *ngIf="showCreateModal"
    (click)="closeCreateModal()">

    <div
      class="specialty-modal specialty-create-modal"
      (click)="$event.stopPropagation()">

      <div class="specialty-modal-header">
        <div>
          <h4>Nueva especialidad</h4>

          <p>
            Define los datos generales y condiciones de atención
            de esta especialidad.
          </p>
        </div>

        <button
          type="button"
          class="specialty-modal-close"
          [disabled]="savingCreate"
          (click)="closeCreateModal()">

          <i class="fi fi-rr-cross-small"></i>
        </button>
      </div>

      <div class="specialty-modal-body">

        <!-- NOMBRE -->

        <div class="specialty-form-field full">
          <label>
            Nombre de la especialidad
            <span>*</span>
          </label>

          <input
            type="text"
            class="form-control"
            [(ngModel)]="newSpecialty.spe_name"
            (blur)="onCreateSpecialtyNameBlur()"
            [class.input-error]="newSpecialtyDuplicate"
            placeholder="Ej. Cardiología">

          <div
            class="specialty-field-error"
            *ngIf="newSpecialtyDuplicate">

            <i class="fi fi-rr-triangle-warning"></i>

            <span>
              Ya existe una especialidad igual o muy similar:
              <strong>
                {{ newSpecialtyDuplicate.spe_name }}
              </strong>.
            </span>
          </div>
        </div>

        <!-- DURACIÓN + TARIFA -->

        <div class="specialty-form-grid">

          <div class="specialty-form-field">
            <label>
              Duración de la consulta
              <span>*</span>
            </label>

            <select
              class="form-control"
              [(ngModel)]="newSpecialty.duration">

              <option [ngValue]="15">15 minutos</option>
              <option [ngValue]="20">20 minutos</option>
              <option [ngValue]="30">30 minutos</option>
              <option [ngValue]="45">45 minutos</option>
              <option [ngValue]="60">60 minutos</option>
            </select>
          </div>

          <div class="specialty-form-field">
            <label>
              Tarifa general
              <span>*</span>
            </label>

            <div class="price-input">
              <span>$</span>

              <input
                type="number"
                [(ngModel)]="newSpecialty.price"
                min="1000"
                max="150000"
                placeholder="14000">
            </div>
          </div>
        </div>

        <div class="specialty-modal-help">
          Esta tarifa corresponde al valor particular general
          de la especialidad, aplicable a todos los profesionales
          que no tengan una tarifa propia habilitada.
        </div>

        <!-- EDADES -->

        <div class="specialty-subsection-title">
          <strong>Rango de edad</strong>

          <span>
            Define qué pacientes pueden acceder a esta especialidad.
          </span>
        </div>

        <div class="specialty-form-grid specialty-age-grid">

          <div class="specialty-form-field">
            <label>
              Edad mínima
              <span>*</span>
            </label>

            <div class="age-input">
              <input
                type="number"
                [(ngModel)]="newSpecialty.spe_min_age"
                min="0"
                max="150">

              <span>años</span>
            </div>
          </div>

          <div class="specialty-form-field">
            <label>
              Edad máxima
              <span>*</span>
            </label>

            <div class="age-input">
              <input
                type="number"
                [(ngModel)]="newSpecialty.spe_max_age"
                min="0"
                max="150">

              <span>años</span>
            </div>
          </div>
        </div>

        <div
          class="specialty-field-error age-range-error"
          *ngIf="!isAgeRangeValid(newSpecialty)">

          <i class="fi fi-rr-triangle-warning"></i>

          <span>
            {{ getAgeRangeError(newSpecialty) }}
          </span>
        </div>

        <!-- ON DEMAND -->

        <div
          class="specialty-option-box"
          [class.enabled]="newSpecialty.spe_is_ondemand">

          <div class="specialty-option-text">
            <strong>
              {{ getOnDemandTitle(newSpecialty.spe_is_ondemand) }}
            </strong>

            <span>
              {{ getOnDemandDescription(newSpecialty.spe_is_ondemand) }}
            </span>
          </div>

          <button
            type="button"
            class="specialty-switch"
            role="switch"
            [class.active]="newSpecialty.spe_is_ondemand"
            [attr.aria-checked]="newSpecialty.spe_is_ondemand"
            (click)="toggleCreateOnDemand()">

            <span class="specialty-switch-circle"></span>
          </button>
        </div>

        <!-- =================================================
             CUSTOMERS
        ================================================== -->

        <div class="specialty-customer-section">

          <div class="specialty-subsection-title customer-title">
            <strong>Clientes asociados</strong>

            <span>
              Selecciona los clientes que tendrán disponible
              esta especialidad. Puedes seleccionar más de uno.
            </span>
          </div>

          <div class="specialty-form-field">
            <label>Agregar cliente</label>

            <select
              class="form-control specialty-customer-select"
              [ngModel]="createCustomerToAdd"
              [disabled]="loadingCustomers || savingCreate"
              (ngModelChange)="onCreateCustomerSelected($event)">

              <option [ngValue]="null">
                {{
                  loadingCustomers
                    ? 'Cargando clientes...'
                    : 'Seleccionar cliente...'
                }}
              </option>

              <option
                *ngFor="
                  let customer of getAvailableCustomers(newSpecialty);
                  trackBy: trackByCustomerObjectId
                "
                [ngValue]="customer.cus_id">

                {{ getCustomerName(customer.cus_id) }}
              </option>
            </select>
          </div>

          <div
            class="specialty-customer-chips"
            *ngIf="
              newSpecialty.cus_ids &&
              newSpecialty.cus_ids.length > 0
            ">

            <div
              class="specialty-customer-chip"
              *ngFor="
                let cusId of newSpecialty.cus_ids;
                trackBy: trackByCustomerId
              ">

              <span class="specialty-customer-chip-name">
                {{ getCustomerName(cusId) }}
              </span>

              <button
                type="button"
                class="specialty-customer-chip-remove"
                [disabled]="savingCreate"
                [attr.aria-label]="'Eliminar ' + getCustomerName(cusId)"
                (click)="removeCreateCustomer(cusId)">
                ×
              </button>
            </div>
          </div>

          <div
            class="specialty-customer-empty"
            *ngIf="
              !loadingCustomers &&
              (
                !newSpecialty.cus_ids ||
                newSpecialty.cus_ids.length === 0
              )
            ">
            No hay clientes seleccionados.
          </div>
        </div>

        <!-- =================================================
             COLOR
        ================================================== -->

        <div class="specialty-color-section">

          <div class="specialty-subsection-title color-title">
            <strong>
              Color de la especialidad
              <span class="required-color">*</span>
            </strong>

            <span>
              Los colores utilizados por otras especialidades
              se muestran bloqueados. Pasa el cursor sobre ellos
              para ver qué especialidad los utiliza.
            </span>
          </div>

          <div class="color-picker-header">
            <span>Colores disponibles</span>

            <span class="available-color-count">
              {{ getCreateAvailableColorsCount() }}
              /
              {{ colores.length }}
            </span>
          </div>

          <div class="specialty-color-picker">

            <div
              class="color-loading"
              *ngIf="loadingColors">
              Cargando colores...
            </div>

            <div
              class="color-empty"
              *ngIf="!loadingColors && colorGroups.length === 0">
              No existen colores registrados.
            </div>

            <ng-container
              *ngIf="!loadingColors && colorGroups.length > 0">

              <div
                class="color-family-group"
                *ngFor="
                  let group of colorGroups;
                  trackBy: trackByColorFamily
                ">

                <div class="color-family-header">
                  <span class="color-family-name">
                    {{ group.family }}
                  </span>

                  <span class="color-family-count">
                    {{ getCreateAvailableColorsInGroup(group) }}
                    /
                    {{ group.colors.length }}
                  </span>
                </div>

                <div class="color-grid">
                  <button
                    type="button"
                    class="color-option"
                    *ngFor="
                      let color of group.colors;
                      trackBy: trackByColorId
                    "
                    [class.selected]="isCreateColorSelected(color)"
                    [class.used]="!isColorAvailableForCreate(color)"
                    [attr.aria-disabled]="!isColorAvailableForCreate(color)"
                    [attr.tabindex]="
                      isColorAvailableForCreate(color)
                        ? 0
                        : -1
                    "
                    [title]="getCreateColorTooltip(color)"
                    (click)="selectCreateColor(color)">

                    <span
                      class="color-circle"
                      [style.backgroundColor]="color.color_hex">
                    </span>

                    <span
                      class="color-check"
                      *ngIf="isCreateColorSelected(color)">
                      ✓
                    </span>

                    <span
                      class="color-used-mark"
                      *ngIf="!isColorAvailableForCreate(color)">
                      ×
                    </span>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="selected-color-preview"
            *ngIf="getSelectedCreateColor() as selectedColor">

            <span
              class="selected-color-circle"
              [style.backgroundColor]="selectedColor.color_hex">
            </span>

            <div class="selected-color-information">
              <strong>
                {{ selectedColor.color_familia }}
              </strong>

              <div class="selected-color-codes">
                <span>{{ selectedColor.color_hex }}</span>
                <span>{{ selectedColor.color_rgb }}</span>
                <span>ID {{ selectedColor.color_id }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ESTADO CREACIÓN -->

        <div class="create-status-info">
          <i class="fi fi-rr-check-circle"></i>

          <div>
            <strong>
              La especialidad se creará activa
            </strong>

            <span>
              Las nuevas especialidades quedan habilitadas
              automáticamente al momento de su creación.
            </span>
          </div>
        </div>
      </div>

      <!-- FOOTER -->

      <div class="specialty-modal-actions">
        <button
          type="button"
          class="specialty-modal-secondary"
          [disabled]="savingCreate"
          (click)="closeCreateModal()">
          Cancelar
        </button>

        <button
          type="button"
          class="specialty-modal-primary"
          [disabled]="!canSaveNewSpecialty()"
          (click)="saveNewSpecialty()">

          {{
            savingCreate
              ? 'Guardando...'
              : 'Guardar especialidad'
          }}
        </button>
      </div>
    </div>
  </div>

  <!-- =====================================================
       MODAL EDITAR
  ====================================================== -->

  <div
    class="specialty-modal-backdrop"
    *ngIf="showEditModal"
    (click)="closeEditModal()">

    <div
      class="specialty-modal specialty-edit-modal"
      (click)="$event.stopPropagation()">

      <div class="specialty-modal-header">
        <div>
          <h4>Editar especialidad</h4>

          <p>
            Modifica los datos generales y condiciones
            de atención de esta especialidad.
          </p>
        </div>

        <button
          type="button"
          class="specialty-modal-close"
          [disabled]="savingEdit"
          (click)="closeEditModal()">

          <i class="fi fi-rr-cross-small"></i>
        </button>
      </div>

      <div class="specialty-modal-body">

        <!-- NOMBRE -->

        <div class="specialty-form-field full">
          <label>
            Nombre de la especialidad
            <span>*</span>
          </label>

          <input
            type="text"
            class="form-control"
            [(ngModel)]="editSpecialty.spe_name"
            (blur)="onEditSpecialtyNameBlur()"
            [class.input-error]="editSpecialtyDuplicate">

          <div
            class="specialty-field-error"
            *ngIf="editSpecialtyDuplicate">

            <i class="fi fi-rr-triangle-warning"></i>

            <span>
              Ya existe otra especialidad igual o muy similar:
              <strong>
                {{ editSpecialtyDuplicate.spe_name }}
              </strong>.
            </span>
          </div>
        </div>

        <!-- DURACIÓN + TARIFA -->

        <div class="specialty-form-grid">

          <div class="specialty-form-field">
            <label>
              Duración de la consulta
              <span>*</span>
            </label>

            <select
              class="form-control"
              [(ngModel)]="editSpecialty.duration">

              <option [ngValue]="15">15 minutos</option>
              <option [ngValue]="20">20 minutos</option>
              <option [ngValue]="30">30 minutos</option>
              <option [ngValue]="45">45 minutos</option>
              <option [ngValue]="60">60 minutos</option>
            </select>
          </div>

          <div class="specialty-form-field">
            <label>
              Tarifa general
              <span>*</span>
            </label>

            <div class="price-input">
              <span>$</span>

              <input
                type="number"
                [(ngModel)]="editSpecialty.price"
                min="1000"
                max="150000">
            </div>
          </div>
        </div>

        <div class="specialty-modal-help">
          Esta tarifa corresponde al valor particular general
          de la especialidad, aplicable a todos los profesionales
          que no tengan una tarifa propia habilitada.
        </div>

        <!-- EDADES -->

        <div class="specialty-subsection-title">
          <strong>Rango de edad</strong>

          <span>
            Define qué pacientes pueden acceder a esta especialidad.
          </span>
        </div>

        <div class="specialty-form-grid specialty-age-grid">

          <div class="specialty-form-field">
            <label>
              Edad mínima
              <span>*</span>
            </label>

            <div class="age-input">
              <input
                type="number"
                [(ngModel)]="editSpecialty.spe_min_age"
                min="0"
                max="150">

              <span>años</span>
            </div>
          </div>

          <div class="specialty-form-field">
            <label>
              Edad máxima
              <span>*</span>
            </label>

            <div class="age-input">
              <input
                type="number"
                [(ngModel)]="editSpecialty.spe_max_age"
                min="0"
                max="150">

              <span>años</span>
            </div>
          </div>
        </div>

        <div
          class="specialty-field-error age-range-error"
          *ngIf="!isAgeRangeValid(editSpecialty)">

          <i class="fi fi-rr-triangle-warning"></i>

          <span>
            {{ getAgeRangeError(editSpecialty) }}
          </span>
        </div>

        <!-- ON DEMAND -->

        <div
          class="specialty-option-box"
          [class.enabled]="editSpecialty.spe_is_ondemand">

          <div class="specialty-option-text">
            <strong>
              {{ getOnDemandTitle(editSpecialty.spe_is_ondemand) }}
            </strong>

            <span>
              {{ getOnDemandDescription(editSpecialty.spe_is_ondemand) }}
            </span>
          </div>

          <button
            type="button"
            class="specialty-switch"
            role="switch"
            [class.active]="editSpecialty.spe_is_ondemand"
            [attr.aria-checked]="editSpecialty.spe_is_ondemand"
            (click)="toggleEditOnDemand()">

            <span class="specialty-switch-circle"></span>
          </button>
        </div>

        <!-- =================================================
             CUSTOMERS
        ================================================== -->

        <div class="specialty-customer-section">

          <div class="specialty-subsection-title customer-title">
            <strong>Clientes asociados</strong>

            <span>
              Agrega o elimina los clientes que tendrán
              disponible esta especialidad.
            </span>
          </div>

          <div class="specialty-form-field">
            <label>Agregar cliente</label>

            <select
              class="form-control specialty-customer-select"
              [ngModel]="editCustomerToAdd"
              [disabled]="loadingCustomers || savingEdit"
              (ngModelChange)="onEditCustomerSelected($event)">

              <option [ngValue]="null">
                {{
                  loadingCustomers
                    ? 'Cargando clientes...'
                    : 'Seleccionar cliente...'
                }}
              </option>

              <option
                *ngFor="
                  let customer of getAvailableCustomers(editSpecialty);
                  trackBy: trackByCustomerObjectId
                "
                [ngValue]="customer.cus_id">

                {{ getCustomerName(customer.cus_id) }}
              </option>
            </select>
          </div>

          <div
            class="specialty-customer-chips"
            *ngIf="
              editSpecialty.cus_ids &&
              editSpecialty.cus_ids.length > 0
            ">

            <div
              class="specialty-customer-chip"
              *ngFor="
                let cusId of editSpecialty.cus_ids;
                trackBy: trackByCustomerId
              ">

              <span class="specialty-customer-chip-name">
                {{ getCustomerName(cusId) }}
              </span>

              <button
                type="button"
                class="specialty-customer-chip-remove"
                [disabled]="savingEdit"
                [attr.aria-label]="'Eliminar ' + getCustomerName(cusId)"
                (click)="removeEditCustomer(cusId)">
                ×
              </button>
            </div>
          </div>

          <div
            class="specialty-customer-empty"
            *ngIf="
              !loadingCustomers &&
              (
                !editSpecialty.cus_ids ||
                editSpecialty.cus_ids.length === 0
              )
            ">
            No hay clientes seleccionados.
          </div>
        </div>

        <!-- =================================================
             COLOR
        ================================================== -->

        <div class="specialty-color-section">

          <div class="specialty-subsection-title color-title">
            <strong>
              Color de la especialidad
              <span class="required-color">*</span>
            </strong>

            <span>
              Tu color actual permanece disponible.
              Los colores utilizados por otras especialidades
              aparecen bloqueados.
            </span>
          </div>

          <div class="color-picker-header">
            <span>Colores disponibles</span>

            <span class="available-color-count">
              {{ getEditAvailableColorsCount() }}
              /
              {{ colores.length }}
            </span>
          </div>

          <div class="specialty-color-picker">

            <div
              class="color-loading"
              *ngIf="loadingColors">
              Cargando colores...
            </div>

            <div
              class="color-empty"
              *ngIf="!loadingColors && colorGroups.length === 0">
              No existen colores registrados.
            </div>

            <ng-container
              *ngIf="!loadingColors && colorGroups.length > 0">

              <div
                class="color-family-group"
                *ngFor="
                  let group of colorGroups;
                  trackBy: trackByColorFamily
                ">

                <div class="color-family-header">
                  <span class="color-family-name">
                    {{ group.family }}
                  </span>

                  <span class="color-family-count">
                    {{ getEditAvailableColorsInGroup(group) }}
                    /
                    {{ group.colors.length }}
                  </span>
                </div>

                <div class="color-grid">

                  <button
                    type="button"
                    class="color-option"
                    *ngFor="
                      let color of group.colors;
                      trackBy: trackByColorId
                    "
                    [class.selected]="isEditColorSelected(color)"
                    [class.used]="!isColorAvailableForEdit(color)"
                    [attr.aria-disabled]="!isColorAvailableForEdit(color)"
                    [attr.tabindex]="
                      isColorAvailableForEdit(color)
                        ? 0
                        : -1
                    "
                    [title]="getEditColorTooltip(color)"
                    (click)="selectEditColor(color)">

                    <span
                      class="color-circle"
                      [style.backgroundColor]="color.color_hex">
                    </span>

                    <span
                      class="color-check"
                      *ngIf="isEditColorSelected(color)">
                      ✓
                    </span>

                    <span
                      class="color-used-mark"
                      *ngIf="!isColorAvailableForEdit(color)">
                      ×
                    </span>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="selected-color-preview"
            *ngIf="getSelectedEditColor() as selectedColor">

            <span
              class="selected-color-circle"
              [style.backgroundColor]="selectedColor.color_hex">
            </span>

            <div class="selected-color-information">
              <strong>
                {{ selectedColor.color_familia }}
              </strong>

              <div class="selected-color-codes">
                <span>{{ selectedColor.color_hex }}</span>
                <span>{{ selectedColor.color_rgb }}</span>
                <span>ID {{ selectedColor.color_id }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ESTADO -->

        <div
          class="specialty-edit-status-box"
          [class.inactive]="!editSpecialty.active">

          <div class="specialty-edit-status-text">
            <strong>
              {{ getEditStatusTitle() }}
            </strong>

            <span>
              {{ getEditStatusDescription() }}
            </span>
          </div>

          <button
            type="button"
            class="specialty-switch"
            role="switch"
            [class.active]="editSpecialty.active"
            [attr.aria-checked]="editSpecialty.active"
            (click)="toggleEditSpecialtyStatus()">

            <span class="specialty-switch-circle"></span>
          </button>
        </div>
      </div>

      <!-- FOOTER -->

      <div class="specialty-modal-actions">
        <button
          type="button"
          class="specialty-modal-secondary"
          [disabled]="savingEdit"
          (click)="closeEditModal()">
          Cancelar
        </button>

        <button
          type="button"
          class="specialty-modal-primary"
          [disabled]="!canSaveEditSpecialty()"
          (click)="saveEditSpecialty()">

          {{
            savingEdit
              ? 'Guardando...'
              : 'Guardar especialidad'
          }}
        </button>
      </div>
    </div>
  </div>

  <!-- =====================================================
       MODAL CAMBIO ESTADO
  ====================================================== -->

  <div
    class="specialty-modal-backdrop specialty-status-backdrop"
    *ngIf="showStatusChangeModal"
    (click)="closeStatusChangeModal()">

    <div
      class="specialty-status-confirm-modal"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()">

      <button
        type="button"
        class="specialty-status-modal-close"
        [disabled]="savingStatusChange"
        (click)="closeStatusChangeModal()">

        <i class="fi fi-rr-cross-small"></i>
      </button>

      <h4 class="specialty-status-modal-title">
        {{ getStatusChangeTitle() }}
      </h4>

      <p class="specialty-status-modal-description">
        {{ getStatusChangeDescription() }}
      </p>

      <div class="specialty-status-modal-actions">

        <button
          type="button"
          class="specialty-status-cancel-btn"
          [disabled]="savingStatusChange"
          (click)="closeStatusChangeModal()">
          Cancelar
        </button>

        <button
          type="button"
          class="specialty-status-confirm-btn"
          [disabled]="savingStatusChange"
          (click)="confirmStatusChange()">

          <ng-container *ngIf="!savingStatusChange">
            Confirmar
          </ng-container>

          <ng-container *ngIf="savingStatusChange">
            {{
              statusChangeTargetActive
                ? 'Activando...'
                : 'Desactivando...'
            }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>

</div>